import { UserTasksState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { ITicketDetail, IUserTasksResponse, IUserTicketsResponse } from '@/interfaces/user_tasks';


export const mutations = {
    setUserTasksResponse(state: UserTasksState, payload: IUserTasksResponse) {
        state.userTasksResponse = payload;
    },
    setUserTicketsResponse(state: UserTasksState, payload: IUserTicketsResponse) {
        state.userTicketsResponse = payload;
    },
    setTicketDetail(state: UserTasksState, payload: ITicketDetail) {
        state.ticketDetail = payload;
    },
};

const {commit} = getStoreAccessors<UserTasksState | any, State>('');

export const commitSetUserTasksResponse = commit(mutations.setUserTasksResponse);
export const commitSetUserTicketsResponse = commit(mutations.setUserTicketsResponse);
export const commitSetUserTicketDetail = commit(mutations.setTicketDetail);
